import { motion } from "framer-motion";
import { containerVariants, itemVariants, vendorData } from "./Data";
import { ArrowRightIcon } from "./Icons";
import { Link } from "react-router-dom";

const VendorSection = () => {
  return (
    <motion.section variants={itemVariants}>
      <div className="text-center lg:text-left mb-8 md:mb-10">
        <h2 className="text-3xl sm:text-4xl font-bold text-slate-700 tracking-tight mb-3">
          Become a <span className="text-sky-600">Vendor</span>
        </h2>
        <p className="text-base md:text-lg text-slate-600 max-w-xl mx-auto lg:mx-0">
          Expand your business by reaching targeted customers, enjoying
          hassle-free selling, and receiving dedicated support.
        </p>
      </div>

      <div className="relative">
        <motion.div
          className="absolute left-7 top-0 w-0.5 bg-sky-200"
          initial={{ height: 0 }}
          whileInView={{ height: "100%" }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, ease: "easeOut" }}
        />

        <motion.div
          className="space-y-12"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
        >
          {vendorData.map((benefit, idx) => (
            <motion.div
              key={idx}
              className="relative pl-20"
              variants={itemVariants}
            >
              <motion.div
                className="absolute left-0 top-0 w-14 h-14 rounded-full flex items-center justify-center bg-sky-100 border-2 border-sky-200 text-sky-700"
                whileHover={{ scale: 1.15, rotate: 10 }}
                transition={{ type: "spring", stiffness: 400 }}
              >
                {benefit.icon}
              </motion.div>

              <div className="ml-2">
                <h3 className="text-xl font-bold text-slate-800 mb-1">
                  {benefit.title}
                </h3>
                <p className="text-slate-600 leading-relaxed">
                  {benefit.description}
                </p>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>

      <motion.div
        className="mt-12 text-center lg:text-left"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5, delay: 0.8 }}
      >
<Link to="/join-our-network">
      <motion.button
        className="bg-slate-800 text-white font-bold py-3 px-10 min-w-[300px] rounded-lg shadow-lg shadow-slate-800/20 hover:bg-slate-900 transition-colors duration-300 flex items-center justify-center gap-2 group"
        whileHover={{ scale: 1.05, y: -3 }}
        whileTap={{ scale: 0.95 }}
        transition={{ type: "spring", stiffness: 400 }}
      >
        Become a Vendor Now
        <span className="group-hover:translate-x-1 transition-transform">
          <ArrowRightIcon className="w-5 h-5" />
        </span>
      </motion.button>
    </Link>




      </motion.div>
    </motion.section>
  );
};

export default VendorSection;
